// src/shared/components/layout/GlobalFooter.jsx
import React from 'react';
import { ThemeToggle } from '../user/theme/theme-toggle.jsx';

const GlobalFooter = () => {
  return (
    <footer className="hidden md:block fixed bottom-0 left-0 right-0 border-t py-4 text-center text-sm text-muted-foreground bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 z-40">
      <div className="flex items-center justify-between px-4 sm:px-6 lg:px-8">
        <p className="text-left">
          Conceptualized by <a 
            href="https://www.1377.co.in/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-primary hover:underline"
          >13°77°</a> and developed in collaboration with <a 
            href="https://mathscapes.xyz" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-primary hover:underline"
          >Mathscapes</a>. Commissioned by <a 
            href="https://drive.google.com/file/d/1ig1VdKZne2DFyQ4S1zR5Er2Ie42GUlNr/view?usp=drivesdk" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-primary hover:underline"
          >Quest Learning Observatory</a>.
        </p>
        <div className="flex-shrink-0">
          <ThemeToggle />
        </div>
      </div>
    </footer>
  );
};

export default GlobalFooter;